import Skeleton from '@mui/material/Skeleton';

export const SkeletonContactList = () => {
  return (
    <>
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
      <Skeleton
        animation="wave"
        height={20}
        width="100%"
        style={{ marginBottom: 6 }}
      />
    </>
  );
};

export const SkeletonApp = () => {
  <>
    <Skeleton
      animation="wave"
      height={40}
      width="100%"
      style={{ marginBottom: 18 }}
    />

    <Skeleton
      animation="wave"
      height='70%'
      width="70%"
      style={{ marginBottom: 6 }}
    />
  </>;
};
